<template>
  <div class="about-wrapper" data-aos="fade-up" data-aos-offset="50">
    <div class="about-text-container">
      <p class="sectionTitle title">Про проєкт</p>
      <p class="text26">
        BEST Company Insight — захід для групи студентів, що відбувається в
        офісі компанії-партнера.
      </p>
      <p class="text26">
        Протягом події учасники знайомляться з внутрішніми процесами компанії,
        слухають лекції, спілкуються з працівниками, залучаються до різних
        активностей, отримують цікавий і корисний досвід.
      </p>
    </div>
    <div class="image-container">
      <img src="@/assets/images/AboutImage.png" alt="#" class="img" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'AboutProject'
};
</script>

<style lang="scss" scoped>
.about-wrapper {
  display: flex;
  justify-content: center;
}
.about-text-container {
  margin-right: 4.8rem;
}
.title {
  margin-bottom: 3.472rem;
}
.img {
  width: 27.778rem;
  height: auto;
}

@media screen and (max-width: 768px) {
  .about-wrapper {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .about-text-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .title {
    margin-bottom: 4.375rem;
  }
  .img {
    display: none;
  }
}
</style>
